<template>
  <div class="controls-container">
    <GruButton :disabled="!gameStarted" type="reset" @click="$emit('reset')" />
    <GruButton
      v-if="isFullscreenEnabled && !isFullscreen"
      type="enter-fullscreen"
      @click="enterFullscreen"
    />
    <GruButton
      v-if="isFullscreenEnabled && isFullscreen"
      type="exit-fullscreen"
      @click="exitFullscreen"
    />
  </div>
</template>

<script>
import GruButton from '@/components/GruButton.vue'
export default {
  name: 'BottomControls',
  components: { GruButton },
  props: { gameStarted: Boolean },
  data() {
    return {
      isFullscreenEnabled: true,
      isFullscreen: false,
    }
  },
  mounted() {
    this.updateFullScreenState()
    // Sadly this seems to be the only reliable way to check for fullscreen that works
    // across all browsers (not mentioning any names... Safari)
    this.fullscreenChecker = setInterval(this.updateFullScreenState, 25)
  },
  beforeDestroy() {
    clearInterval(this.fullscreenChecker)
  },
  methods: {
    updateFullScreenState() {
      this.isFullscreen =
        document.fullscreenElement != null ||
        document.webkitCurrentFullScreenElement != null
    },
    enterFullscreen() {
      const elem = document.getElementById('app')
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
  },
}
</script>

<style scoped>
.controls-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px;
}

.controls-container > * + * {
  margin-left: 1rem;
}
</style>
